import type { ProductMedia } from "@lib/product/types";
import { Button } from "@ecco/ui/button";
import { Flex } from "@ecco/ui/flex";
import { memo } from "react";
import { ProductImageFrame } from "@ecco/ui/product-image-frame";
import type { ECCOIconProps } from "@ecco/ui/ecco-icon";

type ProductImageThumbnailProps = {
    index: number;
    currentlySelected: boolean;
    media: ProductMedia;
    setImageIndex: (index: number) => void;
    alt: string;
    overlay?: ECCOIconProps["name"];
};

export const ProductImageThumbnail = memo(
    ({
        index,
        currentlySelected,
        media,
        setImageIndex,
        alt,
        overlay,
    }: ProductImageThumbnailProps) => {
        const beforePseudoElementStyles = {
            content: "''",
            position: "absolute",
            left: "0",
            bottom: "0",
            width: "100%",
            height: "1.7px",
            backgroundImage: " linear-gradient(#000,#000)",
            transition: "transform .2s ease-in-out",
            willChange: "transform",
            transformOrigin: "left bottom",
        };

        return (
            <Flex
                as={Button}
                variant={"unstyled"}
                key={media.url}
                h={["100%", "100%"]}
                px={[0, 0, 0, 0]}
                onClick={() => setImageIndex(index)}
                //@TODO: Intl of labels.
                aria-label={`Product image ${media.label ?? index}`}
                aspectRatio="2/3"
                order={index === 0 ? 0 : index + 1}
                sx={{
                    " &::before": {
                        ...beforePseudoElementStyles,
                        transform: currentlySelected ? "scaleX(1)" : "scaleX(0)",
                    },
                }}
            >
                <ProductImageFrame
                    src={media.url}
                    alt={alt}
                    quality={50}
                    sizes={["5vw"]}
                    overlayIcon={overlay}
                />
            </Flex>
        );
    }
);

ProductImageThumbnail.displayName = "ProductImageThumbnail";
